__turbopack_context__.v({
  "active": "style-module-scss-module__2TKLyG__active",
  "clicked": "style-module-scss-module__2TKLyG__clicked",
  "container": "style-module-scss-module__2TKLyG__container",
  "desktop": "style-module-scss-module__2TKLyG__desktop",
  "divider": "style-module-scss-module__2TKLyG__divider",
  "mobile": "style-module-scss-module__2TKLyG__mobile",
  "reports": "style-module-scss-module__2TKLyG__reports",
  "surveys": "style-module-scss-module__2TKLyG__surveys",
});
